export function Tag({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-block bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded dark:bg-gray-700 dark:text-gray-300">
      {children}
    </span>
  )
}
